// extracted by css-extract-rspack-plugin
export default {"sandwich":"sandwich-vqh2AV","stretch":"stretch-EnQbnU","full":"full-YrKezA","bun":"bun-Wy7oOT","content":"content-Vfewu3"};